export default "__VITE_ASSET__9c9a9ab7__"